import { ListItem, ListItemProps } from '@material-ui/core'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import {
  supportPageContext,
  validatedSupportPageContext
} from '../../helpers/supportLaunchContext'
import { getTranslate, lang } from '../../localization'

interface WalletTransactionSupportActionProps
  extends Pick<ListItemProps<'div'>, 'autoFocus' | 'tabIndex' | 'role'> {
  transactionID: string
  /** Required: a stale or failed list must not launch a ticket. No safe default. */
  available: boolean
}

const WalletTransactionSupportAction = React.forwardRef<
  HTMLDivElement,
  WalletTransactionSupportActionProps
>(function WalletTransactionSupportAction(
  { transactionID, available, ...menuItemProps },
  ref
) {
  const history = useHistory()
  const { pathname } = useLocation()
  const state = validatedSupportPageContext({
    ...supportPageContext(pathname),
    relatedWalletTransactions: [{ id: transactionID }]
  })
  const ready =
    available &&
    state?.pageKey === 'wallet.transaction' &&
    state.relatedWalletTransactions?.length === 1
  return (
    <ListItem
      {...menuItemProps}
      ref={ref}
      component="div"
      button
      disabled={!ready}
      onClick={() => {
        if (ready)
          history.push({ pathname: `/${lang}/support/tickets/create`, state })
      }}>
      {getTranslate('Report a problem with this transaction')}
    </ListItem>
  )
})

export default WalletTransactionSupportAction
